(() => {
  // Keep navigation inside the same draft during a Shopify theme preview.
  const preservePreview = () => {
    const previewId = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (!previewId) return;
    document.querySelectorAll('[data-mafraria-link]').forEach((link) => {
      const target = new URL(link.href, window.location.origin);
      if (target.origin !== window.location.origin) return;
      target.searchParams.set('preview_theme_id', previewId);
      link.href = target.pathname + target.search + target.hash;
    });
  };
  preservePreview();
  document.addEventListener('shopify:section:load', preservePreview);
})();
